export const transformObjectToSortedArray = (records: Record<string, number>) =>
  Object.entries<number>(records)
    .sort(([, aIndex], [, bIndex]) => aIndex - bIndex)
    .map(([key]) => key)
